import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';

@Component({
  selector: 'app-oAuth',
  templateUrl: './oAuth.component.html'
})
export class OAuthComponent implements OnInit {
  Code: string = "";
  Heading: string = "";
  Information: string = "";
  CloseButtonText: string = "";
  CloseButtonVisibility: boolean = false;

  constructor(
    private apiService: APIService
  ) { }

  ngOnInit() {
    this.CloseButtonVisibility = false;
    this.Heading = Constants.oAuthAuthenticatingHeading;
    this.Information = Constants.oAuthAuthenticatingInformation;
    this.CloseButtonText = Constants.oAuthCloseButton;
    this.ProcessTokens();
  }

  public ProcessTokens() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      this.Code = urlParams.get('code');
      GlobalConstants.Tid = decodeURI(urlParams.get('q').replace(" ", "+").replace('%20', '+'));
      window.history.pushState({}, document.title, window.location.origin);
      if (this.Code.length > 0 && GlobalConstants.Tid.length > 0) {
        this.GenerateTokens();
      }
    } catch (e) {

    }
  }

  public GenerateTokens() {
    this.apiService.getTokens(this.Code)
      .subscribe(data => {
        GlobalConstants.Jwi = "";
        if (data['Key'] == "Authenticate" && String(data['Value']).length > 0) {
          GlobalConstants.Jwi = data['Value'];
          this.CloseButtonVisibility = true;
          this.Heading = Constants.oAuthAuthenticatedHeading;
          this.Information = Constants.oAuthAuthenticatedInformation;
          this.CloseButtonText = Constants.oAuthCloseButton;
        }
      })
  }

  public Close() {
    window.close();
  }
}
